import { Drawer } from "antd";
import { useTranslation } from "react-i18next";
import ShareData from "components/shareData";
import { ReactComponent as OutlinedDownload } from "assets/icons/outlined-download.svg";
import { ReactComponent as OutlinedAttachSquare } from "assets/icons/outlined-attach-square.svg";
import { ReactComponent as Chat } from "assets/icons/chat.svg";

export default function ReceiptSharingDrawer({
  open,
  shareWithImageText = {},
  onDownloadImage,
  onShareImage,
  onClose,
}) {
  const { t } = useTranslation();

  const list = [
    {
      id: "sharing_id_3",
      data: shareWithImageText,
      title: t("bank.share-with-text"),
      Icon: <Chat width={20} height={20} className="share-with-text" />,
    },
  ];

  return (
    <Drawer
      closable
      key="bottom"
      open={open}
      title={t("bank.receipt-sharing")}
      placement={window.innerWidth < 768 ? "bottom" : "left"}
      onClose={onClose}
    >
      <div
        className={`flex cursor-pointer items-center py-4 gap-5  border-b ${
          navigator?.canShare ? "border-gray--7" : ""
        }`}
        onClick={onDownloadImage}
      >
        <div className="bg-primary--8 rounded-lg p-2">
          <OutlinedDownload
            width={20}
            height={20}
            className="[&>path]:fill-primary-0"
          />
        </div>
        <p className=" body-14px-medium">{t("bank.download-image")}</p>
      </div>
      <div
        className={`flex cursor-pointer items-center py-4 gap-5  border-b ${
          navigator?.canShare ? "border-gray--7" : ""
        }`}
        onClick={onShareImage}
      >
        <div className="bg-primary--8 rounded-lg p-2">
          <OutlinedAttachSquare
            width={20}
            height={20}
            className="[&>path]:fill-primary-0"
          />
        </div>
        <p className=" body-14px-medium">{t("bank.share-with-image")}</p>
      </div>

      {list.map(
        (el) =>
          navigator?.canShare && (
            <ShareData key={el.id} data={el.data} className="w-full">
              <div className="flex cursor-pointer items-center py-4 gap-5  border-b border-gray--7">
                <div className="bg-primary--8 rounded-lg p-2">{el.Icon}</div>
                <p className=" body-14px-medium">{el.title}</p>
              </div>
            </ShareData>
          )
      )}
    </Drawer>
  );
}
